import { IMobileWaypoint, ISail } from '../interfaces';

export function getRequestFormBtnProps(
    url: string,
    sail: ISail,
    cheapestCabinNidForSail: number,
): string {
    const cabinPart = cheapestCabinNidForSail
        ? cheapestCabinNidForSail
        : sail?.minPriceCabin?.cabinType?.nid ?? '';
    return `${url}/${sail?.nid}/${cabinPart}`;
}

export const getHarbourEmbarkations = ({
    waypoints,
}: {
    waypoints: IMobileWaypoint[];
}): { start: string; end: string } => {
    const portOfEmbarkation = waypoints.find((waypoint) => waypoint.isPortOfEmbarkation);
    const portOfDisembarkation = waypoints.find((waypoint) => waypoint.isPortOfDisembarkation);
    const startHarbour = portOfEmbarkation ? portOfEmbarkation.title : null;
    const endHarbour = portOfDisembarkation ? portOfDisembarkation.title : null;
    return { start: startHarbour, end: endHarbour };
};

export const getDepartureDate = ({ sails, dateRange }: { sails: ISail[]; dateRange: string }) => {
    if (sails.length > 1) return dateRange;
    return sails.length === 1 ? sails[0].label.split(' - ')[0] : null;
};
